import { GroupSecurity } from '@quromedical/fhir-common';
import { useNavigation } from '@react-navigation/native';
import { Col } from 'components/base';
import { WithGroup } from 'core/auth';
import { NavigateToTask, TaskList } from 'core/task';
import { UrgentClinicalReviewList, RealtimeAlertsList, CommunicationAlertList } from 'core/vitals';
import { Grid, Section } from 'design-system';
import { usePractitionerTasks } from 'hooks/useTasks';
import { TaskApi } from 'integration/aggregate';
import React, { useCallback } from 'react';
import { ScrollView } from 'react-native-gesture-handler';

const taskApi = new TaskApi();

export const HomeScreen: React.FC = () => {
  const navigation = useNavigation();
  const navigate = useCallback<NavigateToTask>(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: Fix typing issue
    link => navigation.navigate(link.screen, link.params),
    [navigation]
  );

  const usePractitionerTaskResult = usePractitionerTasks();

  return (
    <ScrollView>
      <Section hasBottomMargin hasTopMargin>
        <WithGroup groups={[GroupSecurity.PatientRead]}>
          <Grid sm={1} lg={2} xl={3} xxxxl={4}>
            <WithGroup groups={[GroupSecurity.CommunicationRead]}>
              <Col>
                <CommunicationAlertList />
              </Col>
            </WithGroup>
            <Col>
              <UrgentClinicalReviewList />
            </Col>
            <WithGroup groups={[GroupSecurity.TaskRead]}>
              <Col>
                <TaskList
                  navigate={navigate}
                  taskListSWRKey={taskApi.userTasksBaseSWRKey}
                  {...usePractitionerTaskResult}
                />
              </Col>
            </WithGroup>
            <WithGroup groups={[GroupSecurity.FeaturePreviewAI]}>
              <Col>
                <RealtimeAlertsList />
              </Col>
            </WithGroup>
          </Grid>
        </WithGroup>
      </Section>
    </ScrollView>
  );
};
